module.exports = __webpack_public_path__ + "static/approach-2-8b6afd3e73d461f0fa5e5f2d4f9af9a0.jpg";